module.exports = __webpack_public_path__ + "static/media/oportunidade.7e2593a2.svg";